import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['userIsCompany'])
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/locks/form/resources/computed.js